import { useState, useEffect } from "react"

export const InitLoadHook = () => {

    const getInitLoad = () => {
        if (typeof document !== 'undefined') {
            return document.querySelector('body').getAttribute('data-animated') === 'true'
        }
    }

    const [initLoad, setInitLoad] = useState(getInitLoad())

    useEffect(() => {
        if (!getInitLoad()) {
            setInitLoad(true)
        }
    }, [])

    return initLoad
}
